<template>
  <IQOS required :title="$t('menu_content_type.title')">
    <BaseTabSwitcher
      fullWidth
      class="w-100 mt-16"
      :tabs="[
        {
          text: $t('menu_content_type.dishes'),
          value: 'dishes',
        },
        {
          text: $t('menu_content_type.drinks'),
          value: 'drinks',
        },
      ]"
      v-model="menuType"
    />

    <p class="mt-16 iqos-comment qrw-paragraph-md">
      {{ $t("menu_content_type.description") }}
    </p>
  </IQOS>
</template>

<script>
export default {
  components: {
  },
  methods: {
    change(v) {},
  },
  computed: {
    menuType: {
      get() {
        return this.menu.content_type;
      },
      set(v) {
        this.$store.commit("menu/setMenuContentType", {
          menu_id: this.menu._id,
          value: v,
        });
        this.$store.commit(
          "menu/changeUnitForAllProducts",
          v == "drinks" ? "l" : "g"
        );
        this.$store.dispatch("menu/save");
      },
    },
    menu() {
      return this.$store.state.menu.current;
    },
  },
};
</script>

<style>
</style>